import { BodyComponent } from "../../components/Global/BodyComponent";
import { Contact } from "../../components/Global/Contact";
import { Footer } from "../../components/Global/Footer";
import { NavBar } from "../../components/Global/NavBar";
import { ImageProjects } from "../../components/ImageProjects";

export const DesignGraphicPage = () => {
    return (
        <BodyComponent>
            <Contact />
            < NavBar />
            
            <ImageProjects />

            <Footer />
        </BodyComponent>
    )
}